import { render, staticRenderFns } from "./CatalogoDigitalProductsTab.vue?vue&type=template&id=702f1b9c&scoped=true"
import script from "./CatalogoDigitalProductsTab.vue?vue&type=script&lang=js"
export * from "./CatalogoDigitalProductsTab.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDigitalProductsTab.vue?vue&type=style&index=0&id=702f1b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f1b9c",
  null
  
)

export default component.exports